/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo, useEffect, useState, type FC } from 'react';
// eslint-disable-next-line import/no-cycle
import FieldLabel from '../common/FieldLabel';
import { SelectStyled } from './styled';
import { selectSVG } from '../Listbox/Button';
import type { ControlProps, Target, Option } from '../../index';
import { sumClasses } from '../../../../utils/misc';

interface SelectProps extends ControlProps {
  label?: any;
  options: Option[];
  onUpdate(e: Target): Promise<void>;
  name: string;
}

const Select: FC<SelectProps> = memo(
  (props) => {
    const { className, style, label, name, disabled, onUpdate, options } = props;
    const labelId = `lb_select_${name}`;
    const [value, setValue] = useState(props.value);

    useEffect(() => {
      if (value !== props.value && !disabled) {
        onUpdate({ target: { name, value } });
      }
    }, [value]);

    useEffect(() => {
      if (value !== props.value) {
        setValue(props.value);
      }
    }, [props.value]);

    return (
      <div {...{ className: sumClasses(['container-field', className || '']), style }}>
        <FieldLabel {...{ label, name, labelId }} />
        <SelectStyled {...{ className: sumClasses(['select-style']) }} disabled={disabled}>
          <select
            {...{
              name,
              id: name,
              value,
              onChange: (e) => setValue(e.target.value),
              disabled,
              'aria-labelledby': sumClasses([name, labelId]),
              style: value === 0 ? { color: '#69767C' } : {},
            }}
          >
            {options.map((item: any) => (
              <option key={`cs_${item.value}`} {...{ value: item.value, disabled: item.disabled }}>
                {item.label}
              </option>
            ))}
          </select>
          {selectSVG}
        </SelectStyled>
      </div>
    );
  },
  (prevProps: SelectProps, nextProps: SelectProps) => {
    if (prevProps.value !== nextProps.value) return false;
    if (prevProps.options !== nextProps.options) return false;
    return true;
  }
);

Select.displayName = 'Select';

export default Select;
